import { isProductSubmission, isValueEmpty } from '../utils';

export function valueContainsAny(
  _givenValue: any,
  expectedValue: any,
): boolean {
  if (isValueEmpty(_givenValue)) {
    return false;
  }
  const givenValue = Array.isArray(_givenValue) ? _givenValue : [_givenValue];

  if (!Array.isArray(givenValue) || !Array.isArray(expectedValue)) {
    throw new Error(
      `Any operator: Unsupported values to compare ${JSON.stringify(
        givenValue,
      )}, ${JSON.stringify(expectedValue)}`,
    );
  }

  if (isProductSubmission(givenValue)) {
    return any(
      givenValue.map((product) => product.productId),
      expectedValue,
    );
  }
  return any(givenValue, expectedValue);
}

function any(givenValue: any[], expectedValue: any[]): boolean {
  return givenValue.some((v) => expectedValue.includes(v));
}
